import React, { useMemo } from 'react';

import { Button, Stack, Section, Picker } from '@gogame/components';
import { FormFieldArray, FormErrorMessage, FormFieldGroup } from '@gogame/form';
import { useQuery } from '@gogame/query';

import {
  APPS_FLYER_PROVIDER,
  MY_TRACKER_PROVIDER,
} from 'scenes/Influencers/MasterCampaigns/constants';
import { loadAgencies } from 'scenes/Influencers/MasterCampaigns/sources/fields';

import { AGENCIES, AGENCY } from '../constants';
import { AppsFlyerAgencies } from './AppsFlyerAgencies';
import { MyTrackerAgencies } from './MyTrackerAgencies';

export const Agencies = ({ attributionProviderId }) => {
  const { data, isFetching } = useQuery('agencies', loadAgencies);
  const Agency = useMemo(() => {
    switch (attributionProviderId) {
      case APPS_FLYER_PROVIDER:
        return AppsFlyerAgencies;
      case MY_TRACKER_PROVIDER:
        return MyTrackerAgencies;
      default:
        return () => null;
    }
  }, [attributionProviderId]);

  return (
    <FormFieldArray name={AGENCIES}>
      {({ push, remove, form }) => {
        const value = form.values[AGENCIES];
        const valueIds = value?.map((v) => v.id);
        const selectableAgencies = data?.filter(
          (a) => !valueIds?.includes(a.id)
        );

        return (
          <Section title={'Agencies *'}>
            <Stack spacing={3}>
              <div>
                <Picker
                  button={<Button add>Agency</Button>}
                  onChange={([agency]) => {
                    push({ [AGENCY]: agency.id });
                  }}
                  options={selectableAgencies}
                  loading={isFetching}
                />
              </div>
              <FormFieldGroup name={AGENCIES}>
                <Agency
                  agencies={value}
                  options={data}
                  onRemove={remove}
                  onRemoveAll={() => form.setFieldValue(AGENCIES, undefined)}
                />
              </FormFieldGroup>
              <FormErrorMessage name={AGENCIES} />
            </Stack>
          </Section>
        );
      }}
    </FormFieldArray>
  );
};

export default Agencies;
